import { useDesignMaxTheme } from "@/packages";
import { Box, Flex } from "@chakra-ui/react";

export const RoomPhotos = ({ imgList }: { imgList: { img_URL: string }[] }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const newImgList = [...imgList].sort(() => Math.random() - 0.5).slice(0, 6);
    return (
        <Flex
            flexDir={isMobile ? "column" : "row"}
            sx={{
                "& .pbox": {
                    flex: isMobile ? "none" : 1,
                    gap: "24px",
                    flexDir: "column",
                },
            }}
            gap="24px"
        >
            <Flex className="pbox">
                <Box
                    h={isMobile ? "256px" : "560px"}
                    background={newImgList[0] ? `url(${newImgList[0].img_URL})no-repeat center/cover` : "gray.100"}
                />
                <Box
                    h={isMobile ? "256px" : "340px"}
                    background={newImgList[1] ? `url(${newImgList[1].img_URL})no-repeat center/cover` : "gray.100"}
                />
            </Flex>
            <Flex className="pbox">
                <Box
                    h={isMobile ? "256px" : "340px"}
                    background={newImgList[2] ? `url(${newImgList[2].img_URL})no-repeat center/cover` : "gray.100"}
                />
                <Box
                    h={isMobile ? "256px" : "560px"}
                    background={newImgList[3] ? `url(${newImgList[3].img_URL})no-repeat center/cover` : "gray.100"}
                />
            </Flex>
            <Flex className="pbox">
                <Box
                    h={isMobile ? "256px" : "560px"}
                    background={newImgList[4] ? `url(${newImgList[4].img_URL})no-repeat center/cover` : "gray.100"}
                />
                <Box
                    h={isMobile ? "256px" : "340px"}
                    background={newImgList[5] ? `url(${newImgList[5].img_URL})no-repeat center/cover` : "gray.100"}
                />
            </Flex>
        </Flex>
    );
};
